export default __webpack_public_path__ + "static/media/Nozzle, Orange.2365addd.png";